export enum ClientRole {
  Primary = 1,
  PortalMember = Primary << 1,
  Sponsor = PortalMember << 1,
}
